import { appContext } from '../../../../AppContext';
import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';
import { JSX } from 'react';
import { PagedResponse } from "@iconics/core";
import { Package, SolutionPackage } from './DataModels';
import { Button, ButtonBar, Card, Dialog, DialogContent, DialogFooter, GridContainer, GridItem, ISelectItem, RightButtons, Select } from '@iconics/components';

class AddSolutionPackageDialog extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            packages: [],
            packageId: '',
        };
    }

    public async componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>): Promise<void>
    {
        if (!prevProps.open && this.props.open)
        {
            await this.handleOpen();
        }
    }

    private async handleOpen(): Promise<void>
    {
        this.setState({ packageId: '' });

        const solutionPackagesData = await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.solutions.byId.packages.get<SolutionPackage[]>({
            id: this.props.solutionId,
            tenancy: appContext().tenantId,
        });

        const solutionPackageIds = solutionPackagesData.map(i => i.Id);

        const allPackagesData = await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.packages.get<PagedResponse<Package[]>>({
            tenancy: appContext().tenantId,
            select: Package,
        });

        const packages = allPackagesData.value
            .filter(i => !solutionPackageIds.includes(i.Id))
            .map(i => ({ value: i.Id, label: i.Name }))
            .sort((a, b) => a.label < b.label ? -1 : 1);

        this.setState({ packages: packages });
    }

    private handleCancel(): void
    {
        this.props.onClose();
    }

    private async handleSave(): Promise<void>
    {
        try
        {
            await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.solutions.byId.addpackage.post({
                tenancy: appContext().tenantId,
                id: this.props.solutionId,
                body: { Package_ID: this.state.packageId }
            });
            this.props.onSave();
        }
        catch (error)
        {
            console.error(error);
        }
    }

    public render(): JSX.Element
    {
        return (
            <Dialog
                isOpen={this.props.open}
                onOpenChange={() => this.handleCancel()}
            >
                <DialogContent>
                    <Card
                        title={this.labels.Platform_EditSolutions_AddPackageTitle}
                        subTitle={this.labels.Platform_EditSolutions_AddPackageTitle}
                    >
                        <GridContainer>
                            <GridItem>
                                <Select
                                    label={this.labels.Platform_Package_Name}
                                    placeholder={this.labels.Platform_Package_Name}
                                    items={this.state.packages}
                                    value={[this.state.packageId]}
                                    onSelect={e => this.setState({ packageId: e.value })}
                                    required
                                />
                            </GridItem>
                        </GridContainer>
                    </Card>
                </DialogContent>
                <DialogFooter>
                    <ButtonBar>
                        <RightButtons>
                            <Button
                                styleType='outlined'
                                onClick={() => this.handleCancel()}
                            >
                                {this.labels.Platform_CommonAction_Cancel}
                            </Button>
                            <Button
                                styleType='filled'
                                onClick={() => this.handleSave()}
                                disabled={this.state.packageId.length === 0}
                            >
                                {this.labels.Platform_CommonAction_Add}
                            </Button>
                        </RightButtons>
                    </ButtonBar>
                </DialogFooter>
            </Dialog>
        )
    }
}

export default AddSolutionPackageDialog;

export interface IProps
{
    solutionId: string;
    open: boolean;
    onClose: () => void;
    onSave: () => void;
}

export interface IState
{
    packages: ISelectItem[];
    packageId: string,
}
